module.exports = __webpack_public_path__ + "static/media/28DGC12.d1a9d5a8.jpg";